import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  public readonly countDemandNotificationSubject = new BehaviorSubject<number>(0);
  public countDemandNotification$: Observable<number> = this.countDemandNotificationSubject.asObservable();

  public readonly countGedNotificationSubject = new BehaviorSubject<number>(0);
  public countGedNotification$: Observable<number> = this.countGedNotificationSubject.asObservable();

  public readonly countDsnNotificationSubject = new BehaviorSubject<number>(0);
  public countDsnNotification$: Observable<number> = this.countDsnNotificationSubject.asObservable();

  public readonly countAmountNotificationSubject = new BehaviorSubject<number>(0);
  public countAmountNotification$: Observable<number> = this.countAmountNotificationSubject.asObservable();

  constructor(private http: HttpClient, private readonly environmentService: EnvironmentService) {
  }

  getNotifications(companyId: number, uuid: string,type) {
    return this.http.get(this.environmentService.get().serverUrl + `/ws/rest/notifications/notifications/${type}`);
  }



  getCountNotifications(notifCount: any,type): Observable<number> {
    return this.http.post<number>(this.environmentService.get().serverUrl + `/ws/rest/notifications/notification/${type}`, notifCount);

  }

}
